import React from 'react';
import { Separator } from '../../Form/Separator';

var SeparatorBuilder = function SeparatorBuilder(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(Separator, {
    className: className
  });
};

export { SeparatorBuilder };